<template>
  <v-app-bar color="#00b888" dense dir="rtl">
    <v-img :width="70" src="./../assets/img/logo-small.png"></v-img>
    <v-app-bar-title>
      ارتباط مستقیم با دبیرخانه شورای عالی حوزه علمیه خراسان</v-app-bar-title
    >
  </v-app-bar>
  <v-container dir="rtl">
    <v-card class="mx-auto" max-width="800">
      <!-- <v-card-title style="background: #00b888; padding: 20px">
        ارتباط مستقیم با دبیرخانه شورای عالی حوزه علمیه خراسان
      </v-card-title> -->
      <v-card-text
        style="border: 1px solid #999; border-top: none; padding: 15px"
        v-if="!sendComment"
      >
        <v-form ref="form" @submit.prevent="submitForm">
          <v-row justify="space-between">
            <v-col cols="12" md="6">
              <v-text-field v-model="form.name" label="نام"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.lastname"
                label="نام خانوادگی"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="space-between">
            <v-col cols="12" md="6">
              <v-text-field v-model="form.email" label="کد ملی"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="form.mobile" label="تلفن"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <span style="font-weight: 700">انتخاب کنید</span>
              <v-radio-group v-model="form.sender" row inline>
                <span>
                  <v-radio label="طلبه" value="طلبه"></v-radio>
                </span>
                <span>
                  <v-radio label="استاد" value="استاد"></v-radio>
                </span>
                <span>
                  <v-radio label="کادر مدارس" value="کادر مدارس"></v-radio>
                </span>
                <span>
                  <v-radio label="غیر طلبه" value="غیر طلبه"></v-radio>
                </span>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <span style="font-weight: 700">جنسیت</span>
              <v-radio-group v-model="form.gender" row inline>
                <span>
                  <v-radio label="مرد" value="مرد"></v-radio>
                </span>
                <span>
                  <v-radio label="زن" value="زن"></v-radio>
                </span>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <span style="font-weight: 700">نوع پیام</span>
              <v-radio-group v-model="form.type" row inline>
                <span>
                  <v-radio label="نظر" value="5"></v-radio>
                </span>
                <span>
                  <v-radio label="انتقاد" value="1"></v-radio>
                </span>
                <span>
                  <v-radio label="پیشنهاد" value="2"></v-radio>
                </span>
                <span>
                  <v-radio label="ایده" value="4"></v-radio>
                </span>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <span style="font-weight: 700">پیام</span>
              <v-textarea
                v-model="form.comment"
                filled
                auto-grow
                style="border: 1px solid #ddd"
              >
              </v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-card
                class="mx-auto"
                outlined
                style="border: 1px solid #ddd; padding: 10px"
              >
                <span
                  style="
                    font-size: 15px;
                    font-weight: 700;
                    display: inline-block;
                    margin-bottom: 10px;
                  "
                >
                  پیوست ها
                </span>
                <br />
                <span style="font-size: 12px; display: block">
                  حداکثر حجم مجاز برای بارگذاری هر پیوست، 5 مگابایت می باشد.
                </span>
                <v-col xs="12" style="display: inline-block">
                  <v-file-input
                    label="فایل PDF"
                    show-size
                    prepend-icon="mdi-file-pdf-box"
                    accept="pdf/*"
                    v-model="form.pdf"
                  ></v-file-input>
                </v-col>
                <v-col xs="12" style="display: inline-block">
                  <v-file-input
                    label="فایل تصویر"
                    show-size
                    prepend-icon="mdi-file-image"
                    accept="image/*"
                    v-model="form.image"
                  ></v-file-input>
                </v-col>
                <v-col xs="12" style="display: inline-block">
                  <v-file-input
                    label="فایل صوتی"
                    show-size
                    prepend-icon="mdi-microphone-settings"
                    accept="voice/*"
                    v-model="form.voice"
                  ></v-file-input>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
          <v-row justify="space-between">
            <span style="margin: 20px">
              <img :src="captchaUrl" style="float: right" />
              <v-icon
                @click="generateCaptcha"
                style="font-size: 36px; margin-right: 20px; color: gray"
              >
                mdi-refresh
              </v-icon>
            </span>
          </v-row>
          <v-row justify="space-between">
            <v-col md="4" sm="12">
              <v-text-field
                v-model="form.captcha"
                label="کد امنیتی را وارد نمایید"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-btn
                type="submit"
                color="success"
                width="100%"
                style="
                  background: rgb(0 184 136) !important;
                  display: inline-block;
                  width: 49%;
                "
              >
                ارسال
              </v-btn>
              <a
                href="/"
                class="my-font"
                style="
                  width: 50%;
                  display: inline-block;
                  text-align: center;
                  padding: 8px;
                  background: #bd8282;
                  margin-bottom: 20px;
                "
                >انصراف</a
              >
            </v-col>
          </v-row>
          <v-row>
            <v-snackbar
              v-model="snackbar"
              :color="snackbarColor"
              absolute
              right
              rounded="pill"
              top
            >
              {{ text }}
              <template v-slot:action="{ attrs }">
                <v-btn
                  color="black"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </template>
            </v-snackbar>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-text
        style="border: 1px solid #999; border-top: none; padding: 15px"
        v-if="sendComment"
      >
        <v-row>
          <div class="d-inline pa-2 accent-4 white--text">
            ثبت پیام با موفقیت انجام شد
          </div>
        </v-row>
        <v-row>
          <div class="d-inline pa-2 accent-4 white--text">
            کد رهگیری درخواست شما
          </div>
          <div class="d-inline pa-2 green--text">
            {{ result }}
          </div>
          <div class="pa-2 accent-4 white--text">می باشد</div>
        </v-row>
        <br />
        <v-row>
          <div class="d-inline pa-2 accent-4 white--text">
            برای پیگیری وضعیت پیام
            <a href="/search">کلیک</a>
            نمایید
          </div>
        </v-row>
      </v-card-text>
    </v-card>
    <div v-if="currentFile">
      <div>
        <v-progress-linear
          v-model="progress"
          color="light-blue"
          height="25"
          reactive
        >
          <strong>{{ progress }} %</strong>
        </v-progress-linear>
      </div>
    </div>

    <v-alert v-if="message" border="left" color="blue-grey" dark>
      {{ message }}
    </v-alert>
  </v-container>
</template>

<script>
//import VueClientRecaptcha from "vue-client-recaptcha";
// import SampleOnSaveWithOptionAPI from "./SampleOnSaveWithOptionAPI.vue";
import axios from "axios";

export default {
  name: "MessagePage",
  data() {
    return {
      currentFile: undefined,
      progress: 0,
      message: "",
      fileInfos: [],
      sendComment: 0,
      result: "",
      multiLine: true,
      snackbar: false,
      snackbarColor: "red accent-2",
      text: "",
      form: {
        name: "",
        lastname: "",
        email: "",
        mobile: "",
        sender: "",
        gender: "",
        type: "",
        comment: "",
        captcha: "",
        image: [],
        pdf: [],
        voice: [],
      },
      upDocs: "",
      files: [],
      file: "",
      formData: new FormData(),
      captchaText: "",
      captchaUrl: "",
    };
  },

  mounted() {
    this.generateCaptcha();
  },
  methods: {
    async sendForm() {
      this.formData = new FormData();

      this.formData.append("comment", this.form.comment);
      this.formData.append("email", this.form.email);
      this.formData.append("gender", this.form.gender);
      this.formData.append("lastname", this.form.lastname);
      this.formData.append("mobile", this.form.mobile);
      this.formData.append("name", this.form.name);
      this.formData.append("sender", this.form.sender);
      this.formData.append("type", this.form.type);
      this.formData.append("captchaInput", this.form.captcha);
      this.formData.append("captchaText", this.captchaText);
      this.formData.append("voice", this.form.voice[0]);
      this.formData.append("file", this.form.image[0]);
      this.formData.append("pdf", this.form.pdf[0]);
      this.formData.append("recipient", process.env.VUE_APP_RECIPIENT_MODE);
      //http://localhost:40188/
      return await axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + "api/comment/save",
          this.formData
        )
        .then((res) => {
          console.log(res.data);
          if (res.data.Success) {
            this.sendComment = true;
            this.result = res.data.Message;
            this.resetForm();
          } else {
            this.snackbar = true;
            this.text = res.data.Message;
            this.snackbarColor = "red accent-2";
            this.generateCaptcha();
          }
        });
    },
    submitForm() {
      if (!this.form.captcha.length) {
        this.snackbar = true;
        this.text = "کد امنیتی را صحیح وارد نمایید";
        this.snackbarColor = "red accent-2";
        return false;
      }
      if (this.form.comment == "") {
        this.snackbar = true;
        this.text = "پیام ثبت نشده است";
        this.snackbarColor = "red accent-2";
        return false;
      }
      this.sendForm();
    },
    resetForm() {
      this.form = {
        name: "",
        lastname: "",
        email: "",
        mobile: "",
        sender: "",
        gender: "",
        type: "",
        comment: "",
        captcha: "",
        image: [],
        pdf: [],
        voice: [],
      };
      this.generateCaptcha();
    },
    async generateCaptcha() {
      return await axios
        .get(process.env.VUE_APP_API_ENDPOINT + "captcha/gettext")
        .then((res) => {
          if (res.status != 200) {
            this.snackbar = true;
            this.text = "خطا در تولید کد امنیتی";
            this.snackbarColor = "red accent-2";
          } else {
            this.captchaText = res.data;
            this.getCaptchaImage();
          }
        });
    },
    async getCaptchaImage() {
      const url =
        process.env.VUE_APP_API_ENDPOINT +
        "captcha/show?text=" +
        this.captchaText;
      const response = await axios.get(url, { responseType: "arraybuffer" });
      if (response.status == 200) {
        const b64 = btoa(String.fromCharCode(...new Uint8Array(response.data)));
        const imgData =
          "data:" + response.headers["content-type"] + ";base64," + b64;

        this.captchaUrl = imgData;
      }
    },
  },
};
</script>
